import RemoveRedEyeRoundedIcon from "@mui/icons-material/RemoveRedEyeRounded";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams, Link } from "react-router-dom";
import { CustomAlert, showToastAlert } from "../../admin/components/CustomAlert";
import { getAllSkills } from "../../services/writerPost";
import { SkillModal } from "./skillModal";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const SkillHome = () => {
    const [loaderOpen, setLoaderOpen] = React.useState(true);
    const [modalOpen, setModalOpen] = React.useState(false);
    const [allSkills, setAllSkills] = React.useState();
    const navigate = useNavigate();
    const { state } = useParams();
    const token = useSelector((state) => state.token);
    // Access the specific search key value
    let searchKeyValue = state;
    if (searchKeyValue == undefined) {
        searchKeyValue = "all";
    }

    const createSkill = () => {
        showToastAlert("Skill Created", "success");
        loadData();
    };

    const { id } = useParams();

    const tableColumns = [
        {
            field: "name",
            headerName: "Skill",
            flex: 1,
            editable: false,
        },
        {
            field: "action",
            headerName: "Action",
            flex: 1,
            minWidth: 230,
            editable: false,
            renderCell: (params) => (
                <div>
                    <Tooltip title="Delete Skill">
                        <Button
                            variant="outlined"
                            className="circular-btn me-2"
                            startIcon={<RemoveRedEyeRoundedIcon />}
                        />
                    </Tooltip>
                </div>
            ),
        },
    ];

    useEffect(() => {
        loadData();
    }, []);

    const loadData = async () => {
        try {
            setLoaderOpen(true);
            const response = await getAllSkills();
            setAllSkills(response.data.skills);
            setLoaderOpen(false);
        } catch (err) {
            throw new Error(err);
        }
    };

    return (
        <div className="container">
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginTop: "20px"
                }}
            >
                <Box mb={3}>
                    <Button
                        variant="outlined"
                        component={Link}
                        to="/writer"
                        startIcon={<ArrowBackIcon />}
                        sx={{ background: "yellow" }}
                    >
                        Home
                    </Button>
                </Box>
                <h1 className="page-title-1 my-3">Skills</h1>
                <button onClick={() => setModalOpen(true)} className="btn btn-primary">
                    New Skill
                </button>
            </div>
            <Box
                sx={{
                    width: "100%",
                    height: {
                        xs: 300, // height for small screens
                        sm: 400, // height for medium screens
                        md: 500, // height for large screens
                        lg: 600, // height for extra-large screens
                        xl: 800, // height for extra-large screens
                    },
                }}
            >
                <DataGrid
                    rows={allSkills}
                    columns={tableColumns}
                    pageSize={10}
                    rowsPerPageOptions={[50]}
                    pagination
                    checkboxSelection
                    disableRowSelectionOnClick
                    slots={{ toolbar: GridToolbar }}
                    disableColumnMenu
                    disableColumnSelector
                    getRowId={(row) => row._id}
                    disableColumnFilter={false}
                    componentsProps={{
                        filterPanel: {
                            logicOperators: false,
                        },
                    }}
                />
                <CustomAlert />
            </Box>
            <SkillModal
                open={modalOpen}
                onClose={() => setModalOpen(false)}
                onCreate={createSkill}
            />
        </div>
    );
};

export default SkillHome;
